import type { RunStatus } from './OrderList.types'

export const RUN_STATUSES_BLOCKING_CART_DROP: RunStatus[] = [
  'RUNNING',
  'CONCLUDED',
  'CANCELLED',
]

export const isRunDropDisabled = (status?: RunStatus) => {
  if (!status) return false
  return RUN_STATUSES_BLOCKING_CART_DROP.includes(status)
}

export const RUN_STATUS_COLORS: Record<RunStatus | 'NO_RUN', string> = {
  PENDING: '#FFA50C',
  RUNNING: '#0D6EFD',
  CONCLUDED: '#00C100',
  CANCELLED: '#FF3355',
  INTERRUPTED: '#FFC2E7',
  NO_RUN: '#C0C0C0',
}

export const STATUS_LABELS: Record<string, string> = {
  production: 'Em produção',
  transport: 'Em transporte',
  delivered: 'Entregue',
  canceled: 'Cancelado',
}

export const RUN_STATUS_LABELS: Record<RunStatus, string> = {
  PENDING: 'Pendente',
  RUNNING: 'Em andamento',
  CONCLUDED: 'Concluída',
  CANCELLED: 'Cancelada',
  INTERRUPTED: 'Interrompida',
}

export const isRunStatus = (status: unknown): status is RunStatus => {
  return (
    status === 'PENDING' ||
    status === 'RUNNING' ||
    status === 'CANCELLED' ||
    status === 'INTERRUPTED' ||
    status === 'CONCLUDED'
  )
}
